function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.92187 7.06491H7.46782C7.79579 7.06108 8.06392 7.32537 8.06392 7.65359C8.06392 7.97989 7.79579 8.24419 7.46782 8.24084H2.92187C2.14621 8.23294 2.14621 7.07257 2.92187 7.06491ZM2.92187 3.67885H13.0789C13.4066 3.67502 13.675 3.93931 13.675 4.26705C13.675 4.59527 13.4066 4.85956 13.0789 4.85573H2.92187C2.59365 4.85956 2.32552 4.59527 2.32552 4.26705C2.32552 3.93931 2.59365 3.67502 2.92187 3.67885ZM1.90418 0C0.858006 0 0 0.857049 0 1.90298V14.3704C0 14.7908 0.525002 14.984 0.79672 14.6637L3.1809 11.8605H14.0973C15.1437 11.8605 16 11.0054 16 9.959V1.90322C16 0.857288 15.1437 0.000239496 14.0973 0.000239496H1.90418V0Z",
  fill: "currentColor"
});

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.b541373f.svg";
export { ForwardRef as ReactComponent };